import React from 'react';
import type {ReactableColumnDef} from '@deviceinsight/ng-ui-components';
import {Checkbox} from '@deviceinsight/ng-ui-basic-components';
import type {BundleVersion} from '@deviceinsight/ng-ui-api-client';
import formatTimestamp from '../../common/formatTimestamp';

const versionColumnDefs = (
	selected:
		| {
				label: string;
				value: string;
		  }
		| null
		| undefined,
	onSelect: (arg0: {value: string; label: string}) => void
): Array<ReactableColumnDef<BundleVersion>> => {
	return [
		{
			name: 'checkbox',
			label: '',
			render: ({name, id}: BundleVersion) => (
				<span data-testid={`select-bundle-version-${id}`}>
					<Checkbox
						type="radio"
						value={!!selected && id === selected.value}
						onChange={() =>
							onSelect({
								value: id,
								label: name
							})
						}
					/>
				</span>
			),
			width: '5%'
		},
		{
			name: 'name',
			label: {
				id: 'updatejobs.name',
				defaultValue: 'Name'
			},
			sortable: true,
			render: ({name}: BundleVersion) => name,
			width: '20%'
		},
		{
			name: 'description',
			label: {
				id: 'updatejobs.description',
				defaultValue: 'Description'
			},
			sortable: true,
			render: ({description}: BundleVersion) => <span className="ellipsis">{description}</span>,
			width: '35%'
		},
		{
			name: 'releasedAt',
			label: {
				id: 'updatejobs.releasedAt',
				defaultValue: 'Published at'
			},
			sortable: true,
			render: ({releasedAt}: BundleVersion) => <span>{releasedAt ? formatTimestamp(releasedAt) : '-'}</span>,
			width: '40%'
		}
	];
};

export default versionColumnDefs;
